var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { Button, message, Alert, Collapse } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { LoadingOutlined } from '@ant-design/icons';
import { Permissions } from '@whatsper/texterchat-common';
import validator from '@rjsf/validator-ajv8';
import { Form as RJSFForm } from '@rjsf/antd';
import { useStore } from '../../../../../../store/rootStore';
import s from './ChannelsForm.module.scss';
const ChannelsActionsForm = ({ entity }) => {
    var _a;
    const { channels, agentsStore } = useStore();
    const { t } = useTranslation();
    const [channelActions, setChannelActions] = useState([]);
    const [actionsLoading, setActionsLoading] = useState(true);
    const [actionFormData, setActionFormData] = useState({});
    const [actionMessages, setActionMessages] = useState({});
    const [executingActions, setExecutingActions] = useState(new Set());
    useEffect(() => {
        if (entity) {
            fetchActions(entity);
        }
    }, [entity]);
    const fetchActions = (account) => __awaiter(void 0, void 0, void 0, function* () {
        setActionsLoading(true);
        try {
            const actions = yield channels.fetchChannelActions(account.channel, account.accountId);
            setChannelActions(actions);
            const initialFormData = {};
            actions.forEach((action) => {
                initialFormData[action.name] = {};
            });
            setActionFormData(initialFormData);
        }
        catch (error) {
            console.error('Failed to fetch channel actions:', error);
            setChannelActions([]);
        }
        finally {
            setActionsLoading(false);
        }
    });
    const onRunAction = (action) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (!entity)
            return;
        setExecutingActions((prev) => new Set(prev).add(action.name));
        setActionMessages((prev) => {
            const updated = Object.assign({}, prev);
            delete updated[action.name];
            return updated;
        });
        try {
            const params = actionFormData[action.name];
            const result = yield channels.runChannelAction(entity.channel, entity.accountId, action.name, params);
            if (result.success) {
                message.success(result.message || t('actionExecutedSuccessfully'));
                setActionMessages((prev) => (Object.assign(Object.assign({}, prev), { [action.name]: { type: 'success', text: result.message || t('actionExecutedSuccessfully') } })));
                setActionFormData((prev) => (Object.assign(Object.assign({}, prev), { [action.name]: {} })));
            }
            else {
                setActionMessages((prev) => (Object.assign(Object.assign({}, prev), { [action.name]: { type: 'error', text: result.message || t('actionExecutionFailed') } })));
            }
        }
        catch (error) {
            const errorMessage = ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || (error === null || error === void 0 ? void 0 : error.message) || t('actionExecutionFailed');
            setActionMessages((prev) => (Object.assign(Object.assign({}, prev), { [action.name]: { type: 'error', text: errorMessage } })));
        }
        finally {
            setExecutingActions((prev) => {
                const updated = new Set(prev);
                updated.delete(action.name);
                return updated;
            });
        }
    });
    const checkActionPermissions = (action) => {
        const permissionsToCheck = [Permissions.Permission.channels_manage];
        if (action.requiredPermissions && action.requiredPermissions.length > 0) {
            permissionsToCheck.push(...action.requiredPermissions);
        }
        ;
        return agentsStore.hasPermissions(permissionsToCheck);
    };
    return (React.createElement("div", { className: s.actionsFormContainer }, actionsLoading ? (React.createElement("div", { className: s.loadingContainer },
        React.createElement(LoadingOutlined, { style: { fontSize: 32 } }))) : channelActions.length === 0 ? (React.createElement("div", { className: s.noActions },
        React.createElement(Trans, { i18nKey: "noActionsAvailable" }))) : (React.createElement("div", { className: s.actionsListContainer },
        React.createElement(Collapse, { accordion: true, defaultActiveKey: (_a = channelActions[0]) === null || _a === void 0 ? void 0 : _a.name }, channelActions
            .filter(checkActionPermissions)
            .map((action) => (React.createElement(Collapse.Panel, { key: action.name, header: React.createElement("div", null,
                React.createElement("h3", { className: s.actionTitle }, action.title),
                action.description && (React.createElement("p", { className: s.actionDescription }, action.description))) },
            action.paramsSchema &&
                action.paramsSchema.properties &&
                Object.keys(action.paramsSchema.properties).length > 0 ? (React.createElement("div", { className: s.actionFormWrapper },
                React.createElement(RJSFForm, { validator: validator, schema: action.paramsSchema, formData: actionFormData[action.name] || {}, onChange: (e) => setActionFormData((prev) => (Object.assign(Object.assign({}, prev), { [action.name]: e.formData }))) },
                    React.createElement(Button, { type: "primary", onClick: () => onRunAction(action), loading: executingActions.has(action.name), className: s.runActionButton },
                        React.createElement(Trans, { i18nKey: "run" }))))) : (React.createElement("div", { className: s.actionFormWrapper },
                React.createElement(Button, { type: "primary", onClick: () => onRunAction(action), loading: executingActions.has(action.name), className: s.runActionButton },
                    React.createElement(Trans, { i18nKey: "run" })))),
            actionMessages[action.name] && (React.createElement(Alert, { message: actionMessages[action.name].text, type: actionMessages[action.name].type === 'success' ? 'success' : 'error', style: { marginTop: 16 }, showIcon: true }))))))))));
};
export default observer(ChannelsActionsForm);
